import React, {useEffect, useState} from "react";
import {Button, Space, Table, message} from "antd";
import moment from "moment";
import {apiClient} from "../../../../services/ApiClient";
import UpdateButton from "../../../buttons/UpdateButton";

export default function VehicleGroupHistory({vehicle, active}) {
  let [loading, setLoading] = useState(false);
  let [records, setRecords] = useState([]);
  let [update, setUpdate] = useState(0);

  useEffect(() => {
    if(active && vehicle && vehicle.id > 0) {
      setLoading(true);
      apiClient.getVehicleGroupsHistory(vehicle.id)
        .then(res => {
          setRecords(res.records);
        })
        .catch(err => message.error(err))
        .finally(() => setLoading(false));
    } else {
      setRecords([]);
    }
  }, [vehicle, active, update]);

  return (
    <>
      <div>
        <Space style={{marginBottom: 16, float: "right"}} direction="horizontal">
          <UpdateButton loading={loading} onClick={() => { setUpdate(u => u + 1) }}/>
        </Space>
      </div>
      <Table
        loading={loading}
        size={'small'}
        sticky
        columns={[
          {
            title: "",
            align: "center",
            width: 30,
          },
          {
            title: 'Начало периода',
            align: "center",
            width: 200,
            render: (text, record, index) => {
              return `${moment(record.create_dt).format('DD.MM.YYYY HH:mm')}`;
            }
          },
          {
            title: 'Конец периода',
            align: "center",
            width: 200,
            render: (text, record, index) => {
              return record.delete_dt
                ? `${moment(record.delete_dt).format('DD.MM.YYYY HH:mm')}`
                : "";
            }
          },
          {
            title: 'Группа',
            render: (text, record, index) => {
              return record.payment_group?.title
            }
          },
          {
            title: "",
            align: "center",
            width: 20,
          }
        ]}
        dataSource={records}
        rowKey="id"
      />
    </>
  )
}